import { type ReactNode } from 'react';
import { FileQuestion } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('text-center py-12', className)}>
      <div className="flex justify-center mb-4">
        {icon || (
          <div className="w-16 h-16 rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center">
            <FileQuestion className="w-8 h-8 text-neutral-400" />
          </div>
        )}
      </div>
      <h3 className="text-lg font-medium text-neutral-900 dark:text-white mb-2">{title}</h3>
      {description && (
        <p className="text-neutral-600 dark:text-neutral-400 max-w-sm mx-auto">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
